import { Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import Loading from "../../../common/components/ui/loading/Loading";
import { pluck } from "../../../common/helpers/pluck";
import { useToastContext } from "../../../common/components/ui/toast/toast.context";
import { updateIndicator } from "../../indicators/services/indicator.api";
import { IIndicators } from "../../../types/Indicators.type";
import FormEditIndicator from "../../indicators/components/forms/FormEditIndicator";

type Props = {
  data: IIndicators;
  onClose: () => void;
};

export default function ModalEditAmbassador(props: Props) {
  const [indicatorId, setIndicatorId] = useState<string | null>(null);
  const { showToast } = useToastContext();
  const [indicatorData, setIndicatorData] = useState<IIndicators>();
  const [formRequestErrors, setFormRequestErrors] = useState([]);

  const notifySuccess = (text: string) => showToast({ text, type: "success" });
  const notifyError = (text: string) => showToast({ text, type: "error" });

  const handleCloseModal = () => {
    props.onClose();
  };

  useEffect(() => {
    if (props.data) {
      setIndicatorData(props.data);
      setIndicatorId(props.data[0]?._id ?? null);
    }
  }, [props.data]);

  async function saveIndicator(dataToSave: IIndicators) {
    try {
      const { ok, data, errors } = await updateIndicator(
        indicatorId as string,
        dataToSave
      );
      if (ok && data) {
        setIndicatorData(data as IIndicators);
        notifySuccess(`Dados atualizados!`);
        return {
          ok,
          data: data as IIndicators,
          errors: errors as [{ message: string; path: string[] }],
        };
      }
      const errorMessage = pluck("errors.0.message", { errors });
      Array.isArray(errors) && setFormRequestErrors(errors as unknown as []);
      notifyError(errorMessage);

      return {
        ok,
        data: data as IIndicators,
        errors: errors as [{ message: string; path: string[] }],
      };
    } catch (err) {
      notifyError("Erro ao tentar salvar indicator, tente novamente");
      return {
        ok: false,
        data: dataToSave,
        errors: [{ message: (err as Error).message, path: [] }],
      };
    }
  }

  return (
    <Modal
      size={"5xl"}
      className="relative"
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black">
        <div className="flex items-center justify-start gap-3">
          <span className="text-black">{`Editando`}</span>
        </div>
      </Modal.Header>
      <Modal.Body
        className="w-full relative border-gray flex flex-col dark:text-black"
        style={{
          minHeight: "calc(100vh - 300px)",
          height: "calc(100vh - 300px)",
        }}
      >
        {indicatorData ? (
          <FormEditIndicator
            onSave={() => (props.onClose(), props.onClose())}
            onSubmit={saveIndicator}
            data={indicatorData}
            formRequestErrors={formRequestErrors}
          />
        ) : (
          <Loading />
        )}
      </Modal.Body>
    </Modal>
  );
}
